module.exports = __webpack_public_path__ + "img/map_canvas.592c2bd7.jpeg";